var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0183 0.566162H3.50696C2.77686 0.566712 2.07681 0.85575 1.56046 1.36984C1.0441 1.88392 0.753636 2.58105 0.752808 3.30822V16.3535C0.753636 17.0808 1.04407 17.778 1.56039 18.2923C2.07672 18.8065 2.77677 19.0958 3.50696 19.0966H11.0183C11.7485 19.0958 12.4485 18.8065 12.9648 18.2923C13.4812 17.778 13.7716 17.0808 13.7724 16.3535V3.30822C13.7716 2.58105 13.4811 1.88392 12.9648 1.36984C12.4484 0.85575 11.7484 0.566712 11.0183 0.566162ZM3.50696 1.83069H11.0183C11.4115 1.83096 11.7885 1.98658 12.0666 2.26338C12.3447 2.54019 12.5012 2.91558 12.5018 3.30718V13.76H2.02347V3.30822C2.02375 2.91644 2.18013 2.54078 2.45828 2.26375C2.73643 1.98672 3.1136 1.83096 3.50696 1.83069ZM11.0183 17.8321H3.50696C3.11342 17.8318 2.73609 17.6759 2.45791 17.3987C2.17973 17.1214 2.02347 16.7455 2.02347 16.3535V15.0266H12.5018V16.3546C12.5015 16.7463 12.3451 17.122 12.067 17.399C11.7888 17.6761 11.4116 17.8318 11.0183 17.8321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobile_phone.82c65ff6586a548486e176f885009807.svg";
export { ForwardRef as ReactComponent };